<div [chart]="stock"></div>